export type TStatus = `${Status}`;

export enum Status {
  SCHEDULED = "scheduled",
  RESCHEDULED = "rescheduled",
  PENDING = "pending",
  CONFIRMED = "confirmed",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
  NO_SHOW = "no_show",
  OVERDUE = "overdue",
}

// Status filter type for UI

export type StatusFilter =
  | "all"
  | "scheduled"
  | "rescheduled"
  | "pending"
  | "confirmed"
  | "completed"
  | "cancelled"
  | "no_show"
  | "overdue";
